import { render } from "./ErrorPage.vue?vue&type=template&id=72d400d6"
import script from "./ErrorPage.vue?vue&type=script&lang=ts"
export * from "./ErrorPage.vue?vue&type=script&lang=ts"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "72d400d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72d400d6', script)) {
    api.reload('72d400d6', script)
  }
  
  module.hot.accept("./ErrorPage.vue?vue&type=template&id=72d400d6", () => {
    api.rerender('72d400d6', render)
  })

}

script.__file = "src/views/errorPage/ErrorPage.vue"

export default script